/**
* Current Openings JS
* -----------------------------------------------------------------------------
*
* All the JS for the Current Openings component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'current-openings',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // gsap.registerPlugin( ScrollTrigger );

      $( '.current-openings select' ).on( 'change', function() {
        // console.log( $( '.current-openings select[name="department"] option:selected' ).val() );
        $.post(
            site_info.ajax_url,
            {
              action: 'll_run_function',
              function: 'll_load_filtered_careers',
              params: {
                department: $( '.current-openings select[name="department"] option:selected' ).val(),
                location: $( '.current-openings select[name="location"] option:selected' ).val(),
              },
            },
            function( data, textStatus, xhr ) {
              data = $.parseJSON( data );
              if ( data.status === 'success' ) {
                // console.log( data );
                let careerCards = '';
                $( data.response.filter_result ).each( function( key, val ) {
                  careerCards += val.template;
                } );
                $( '.current-openings .careers-list' ).html( careerCards );
              }
            }
        );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'current-openings', COMPONENT );
} )( app );
